import { formatNumber } from '../../../utils/formatUtils';

/**
 * Equivalente en dólares de una apertura, con dos decimales.
 * @param {number|null} value Importe USD.
 * @returns {string} Importe formateado o `-` si falta.
 */
export const formatOpeningUsd = (value) =>
  value == null ? '-' : `US$ ${formatNumber(value, { decimals: 2 })}`;
